<template>
    <div class="cart-notification-popup active">
        <p>{{productName}} has been added to cart</p>
    </div>
</template>

<script>
    export default {
        computed: {
            productName() {
                return this.$store.state.addToCart.name
            },
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/product/AddToCart.vue